import { PropertyFilterProps } from '@cloudscape-design/components';

/**
 * Reusable i18n strings for Cloudscape PropertyFilter component
 * These strings are required by the PropertyFilter component and provide
 * consistent user-facing text across all filter implementations.
 */
export const PROPERTY_FILTER_I18N_STRINGS: PropertyFilterProps.I18nStrings = {
  filteringAriaLabel: "Filter items",
  dismissAriaLabel: "Dismiss",
  filteringPlaceholder: "Search",
  groupValuesText: "Values",
  groupPropertiesText: "Properties",
  operatorsText: "Operators",
  operationAndText: "and",
  operationOrText: "or",
  operatorContainsText: "Contains",
  operatorDoesNotContainText: "Does not contain",
  operatorEqualsText: "Equals",
  operatorDoesNotEqualText: "Does not equal",
  editTokenHeader: "Edit filter",
  propertyText: "Property",
  operatorText: "Operator",
  valueText: "Value",
  cancelActionText: "Cancel",
  applyActionText: "Apply",
  allPropertiesLabel: "All properties",
  clearFiltersText: "Clear filters",
  removeTokenButtonAriaLabel: () => "Remove filter",
  enteredTextLabel: (text) => `Use: "${text}"`,
};
